export default __webpack_public_path__ + "static/media/spinner.0b06435c.gif";